import apiClient from '@/services/api/clients/api-client.js'
import { API_URL } from '@/config'

const path = `${API_URL}/groups`

const client = apiClient.build(path)

export default client
